'use strict';

import { ListAnalytic } from "../analytics/ListAnalytics";
import { ListAnalyticV1 } from "../analytics/ListAnalyticsV1";


window.app.controller('controller', controller);

controller.$inject = ["$scope", "$http", "$timeout", "localStorageService", "$filter"];

function controller($scope, $http, $timeout, localStorageService, $filter) {
    let vm = this;
    let _response = {};
    let map = null;
    let _distance;
    let origin;
    let destination;
    let id_map;
    let filter = [];
    let transportEmail = {};
    let config = __mt.setting;
    

    window.map_load = window.map_load || false;
    window.__mt.list = {};

    vm.lists = window.__mt.squeletons.list || [];
    vm.mobile = window.__mt.fn.mobileAndTabletCheck();
    vm.loading = true;
    vm.showMap = false;
    vm.filters = false;
    vm.no_results = false;
    vm.mobile = window.__mt.fn.mobileAndTabletCheck();
    vm.ln = window.__mt.ln;
    vm.convertion = window.__mt.setting.exchange.convertion;
    vm.rountrip = 1;
    vm.showNoResultsMap = false;
    vm.box = null;
    vm.filters = {};
    vm.distance = {
        duration: {
            value: 0
        },
        distance: {
            value: 0
        }
    };

    vm.filter_setting = {
        price: {},
        passengers: {},
        suitcases: {}
    }

    vm.init = function () {
        if (isValidRequest()) {
            setText();
            getTransports();
        } else {
            vm.loading = false;
            vm.lists = [];
            vm.no_results = true;
            goNoResults();
        }

    }

    vm.initMap = function () {
        vm.showMap = !vm.showMap;
        id_map = document.getElementById("map");
        $("#c-map").show();
        if (!map && !window.google) {
            window.__mt.fn.getScript(window.__mt.setting.google_map, {}, onLoadMap);
        } else {
            onLoadMap()
        }
    }

    vm.initFilter = function () {
        vm.filters = !vm.filters;
    }

    vm.checkout = function (item, l_index) {
        GoogleAddToCart(item, l_index);

        vm.loading = true;
        var session = {
            session: _response.response.sessionId,
            transports: []
        }

        localStorageService.set('checkout', item);
        localStorageService.set('quote', window.__mt.setting.box);
        localStorageService.set('session', session);


        location.href = window.__mt.setting.checkout_page;
    }

    vm.calculateDelayTime = function (list) {
        var time_google = vm.distance && vm.distance.duration ? vm.distance.duration.value || 0 : 0;
        var time_transport = 0; //list.delayTime || 0;
        var time = (time_google + (time_transport * 60)) / 60;
        return time;
    }



    vm.addExtra = function (item) {
        //item.active = !item.active;

        if (item.active) {
            filter.push(item.extraId);
        } else {
            var index = filter.indexOf(item.extraId);

            if (index !== -1) {
                filter.splice(index, 1);
            }
        }


    };


    vm.filter = function (item) {
        var f_price = rangePrice(item);
        var f_passengers = rangePassengers(item);
        var f_suitcases = rangeSuitcases(item);
        var category = filterByCategory(item);

        return f_price && f_passengers && f_suitcases && category;
    };


    vm.sendBy = function (_transport, type) {
        switch (type) {
            case 'wa':
                byWA(_transport);
                break;
            case 'email':
                byEmail(_transport);
                break;
        }
    }

    vm.sendEmail = function (_transport) {
        console.log(_transport);
        var box = window.__mt.setting.box;
        var params = {
            email: vm.email_offer,
            data: {
                adults: box.adults,
                arrival_date: box.arrival_date,
                arrival_lat: box.arrival_lat,
                arrival_lng: box.arrival_lng,
                children: box.children,
                departure_date: box.departure_date,
                departure_lat: box.departure_lat,
                departure_lng: box.departure_lng,
                infants: box.infants,
                transfer_type: box.transfer_type,
                lang: window.__mt.ln.lang,
                arrival_type: box.arrival_type,
                departure_type: box.departure_type,
                from: box.from,
                to: box.to,
            },
            transport: transportEmail
        }

        $http.post(window.__mt.setting.api_email, params).then(console.log, console.log);
        $("#modal_offer").modal("hide");
    }

    vm.getIconExtra = function (name) {
        return name.replace(/\s/g, '').toLowerCase()
    }

    vm.showBanner = function (position) {
        if (position == 0) {
            return false;
        }
        return (position % 3) == 0;
    }

    vm.openFilters = function (t) {
        if (t == 'open') {
            $("#c-filters").show();
        }

        if (t == 'close') {
            $("#c-filters").hide();
        }
    }

    vm.getDiscount = function(list){
        let percent = 1 + (list.promotionPercent / 100);
        let price = list.price;
        let total = (price * percent) * vm.convertion;
        return $filter('currency')(total, vm.ln.currency_code);
    }

    function byWA(_transport) {
        var box = window.__mt.setting.box;
        var params = {
            adults: box.adults,
            arrival_date: box.arrival_date,
            arrival_lat: box.arrival_lat,
            arrival_lng: box.arrival_lng,
            children: box.children,
            departure_date: box.departure_date,
            departure_lat: box.departure_lat,
            departure_lng: box.departure_lng,
            infants: box.infants,
            transfer_type: box.transfer_type,
            lang: window.__mt.ln.lang,
            arrival_type: box.arrival_type,
            departure_type: box.departure_type,
            from: box.from,
            to: box.to,
            client_api_key: box.client_api_key ?? '',
        };

        var url = window.__mt.setting.search_page + "?" + window.__mt.fn.encodeUrl(params);
        $http.post(window.__mt.setting.api_urlshort, {
            url: url
        }).then((data) => {

            var text = window.__mt.ln.send_by + " \n " + data.data.url;
            window.open(window.__mt.setting.whatsapp + "?text=" + window.encodeURIComponent(text), "_target");

        })

    }


    function byEmail(_transport) {
        $("#modal_offer").modal("show");
        transportEmail = _transport;
    }

    function rangePrice(item) {
        var MAX_PRICE = vm.filter_setting.price.max + 1;
        var MIN_PRICE = vm.filter_setting.price.min - 1;
        var ticket = item.price;
        return ticket >= MIN_PRICE && ticket <= MAX_PRICE;

    }


    function rangePassengers(item) {
        //var MAX = vm.filter_setting.passengers.max + 1;
        var MIN = vm.filter_setting.passengers.min;
        var ticket_min = item.minPassengers;
        var ticket_max = item.maxPassengers;

        return ticket_max >= MIN;

    }

    function rangeSuitcases(item) {
        var MAX = vm.filter_setting.suitcases.max + 1;
        var MIN = vm.filter_setting.suitcases.min - 1;
        var ticket = item.suitcases;
        return ticket >= MIN && ticket <= MAX;

    }

    function filterByCategory(item) {

        var length = filter.length;
        if (!length) {
            return true;
        }
        var result = $filter('filter')(item.extras, filterCategory);
        return result && result.length;
    }

    function filterCategory(item) {
        return filter.indexOf(item.extraId) !== -1;
    }





    function getTransports() {
        var user = __mt.setting.user || {};
        var box = window.__mt.setting.box;
        var params = {
            params: {
                adults: box.adults,
                arrival_date: box.arrival_date,
                arrival_time: box.arrival_time,
                arrival_lat: box.arrival_lat,
                arrival_lng: box.arrival_lng,
                children: box.children,
                departure_date: box.departure_date,
                departure_time: box.departure_time,
                departure_lat: box.departure_lat,
                departure_lng: box.departure_lng,
                infants: box.infants,
                type: box.transfer_type,
                lang: window.__mt.ln.lang,
                transfer: box.transfer,
                user_id: user.id,
                user_type: user.type,
                origin: box.from,
                destination: box.to,
                client_api_key: box.client_api_key ?? ''
            }
        };
        $http.get(window.__mt.setting.api_list, params).then(onResponse, onError);
    }

    function onResponse(data) {
        _response = data.data;
        if (_response.code == 200 && _response.response.transferPriceList) {
            vm.lists = _response.response.transferPriceList || [];
            window.__mt.list = _response.response;
            initVarFilter(_response);
            goSectionList();
            getDistance();
            initSlider();
            GoogleViewItemList()
            $timeout(() => {
                initToogle();

            }, 2000)


        } else {
            vm.lists = [];

            initNoResultMap();
            goNoResults()
        }

        vm.loading = false;

    }

    function onError(data) {
        vm.loading = false;
        vm.lists = [];
        vm.no_results = true;
        initNoResultMap();
        goNoResults();

    }


    function setText() {
        var box = window.__mt.setting.box || {};
        var text = (box.from || "") + " | " + (box.arrival_date || ""); //+ " | " + (getTimeFormat(box.arrival_time));
        var text_dropoff = (box.to || "") + (box.transfer_type == "roundtrip" ? " | " + (box.departure_date || "") /*+ " | " + (getTimeFormat(box.departure_time))*/ : "");

        $("#list-pickup").html(text);
        $("#list-dropoff").html(text_dropoff);

    }


    function getTimeFormat(time) {
        var t = "";
        try {
            var hour = time.substring(0, 2);
            var minute = time.substring(2, 4);
            t = hour + ":" + minute + " hrs";
        } catch (error) {
            t = "";
        }
        return t;
    }

    function initToogle() {
        var acc = document.getElementsByClassName("accordion");
        var i;

        for (i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function () {
                this.classList.toggle("active");
                var panel = this.nextElementSibling;
                if (panel.style.display === "block") {
                    panel.style.display = "none";
                } else {
                    panel.style.display = "block";
                }
            });
        }
    }

    function isValidRequest() {
        var valid = false;
        if (window.__mt.setting.box) {
            if (window.__mt.setting.box.adults && window.__mt.setting.box.arrival_date && window.__mt.setting.box.transfer_type) {
                valid = true;
                vm.box = window.__mt.setting.box || {};
                vm.rountrip = window.__mt.setting.box.transfer_type == 'roundtrip' ? 2 : 1;
            }
        }
        return valid
    }

    function initNoResultMap() {
        vm.showNoResultsMap = true;
        id_map = document.getElementById("map-no-results");
        if (!map && !window.google) {
            window.__mt.fn.getScript(window.__mt.setting.google_map, {}, loadMapNoResults);
        } else {
            onLoaloadMapNoResultsMap()
        }
    }

    function onLoadMap() {
        var data = window.__mt.setting.box;
        if (data.arrival_lat && data.arrival_lng && data.departure_lat && data.departure_lng) {
            var options = {
                center: {
                    lat: +data.arrival_lat,
                    lng: +data.arrival_lng
                },
                disableDefaultUI: true
            }

            map = new google.maps.Map(id_map, options);


            var pointA = {
                lat: +data.arrival_lat,
                lng: +data.arrival_lng,
            }

            var pointB = {
                lat: +data.departure_lat,
                lng: +data.departure_lng,
            }

            var directionsService = new google.maps.DirectionsService()
            var directionsDisplay = new google.maps.DirectionsRenderer();
            directionsDisplay.setMap(map);

            window.__mt.fn.createRoute(pointA, pointB, map, directionsService, directionsDisplay)

        }
    }

    function loadMapNoResults() {

        var data = window.__mt.setting.box;
        if (data.arrival_lat && data.arrival_lng && data.departure_lat && data.departure_lng) {

            var mapOptions = {
                center: new google.maps.LatLng(+data.arrival_lat, +data.arrival_lng),
                zoom: 6,
                treetViewControl: false,
                mapTypeControl: false,
                disableDefaultUI: true

            };

            map = new google.maps.Map(id_map, mapOptions);

            var markera = new google.maps.Marker({
                position: new google.maps.LatLng(+data.arrival_lat, +data.arrival_lng),
                draggable: false
            });

            var markerb = new google.maps.Marker({
                position: new google.maps.LatLng(+data.departure_lat, +data.departure_lng),
                draggable: false
            });

            markera.setMap(map);
            markerb.setMap(map);

            var bounds = new google.maps.LatLngBounds();
            bounds.extend(markera.getPosition())
            bounds.extend(markerb.getPosition())



            map.setCenter(bounds.getCenter());
            map.fitBounds(bounds);


        }

    }

    function goSectionList() {
        var offset = -20;
        $('html, body').animate({
            scrollTop: $("#section_list").offset().top + offset
        }, 500);
    }

    function goNoResults() {
        var offset = -100;
        $timeout(() => {
            $('html, body').animate({
                scrollTop: $("#no-results").offset().top + offset
            }, 500);
        }, 700)


    }

    function getDistance() {

        var quote = window.__mt.setting.box;

        origin = quote.arrival_lat + "," + quote.arrival_lng;
        destination = quote.departure_lat + "," + quote.departure_lng;
        var distance = localStorageService.get('distance');


        if (distance && distance.data && distance.origin == origin && distance.destination == destination) {
            _distance = distance;
            setDistance();
            return;
        }


        var params = {
            params: {
                origins: origin,
                destinations: destination,
            }
        }
        $http.get(window.__mt.setting.api_distance, params).then(onSuccessDistance, console.log);
    }

    function setDistance() {
        if (_distance) {
            if (_distance.data && _distance.data.rows && _distance.data.rows.length) {
                vm.distance = _distance.data.rows[0].elements.length ? _distance.data.rows[0].elements[0] : vm.distance;
            }
        }
    }

    function onSuccessDistance(data) {
        var response = data.data;
        if (response.status == 'OK') {
            var distance = {};
            distance.data = response;
            distance.origin = origin;
            distance.destination = destination;
            localStorageService.set("distance", distance)
            _distance = distance;
            setDistance();
        }
    }

    function initVarFilter(_response) {
        vm.filters = _response.filter || {};
        if (_response.filter) {
            vm.filter_setting.price.min = _response.filter.prices.min;
            vm.filter_setting.price.max = _response.filter.prices.max;

            vm.filter_setting.passengers.min = _response.filter.passengers.min;
            vm.filter_setting.passengers.max = _response.filter.passengers.max;

            vm.filter_setting.suitcases.min = _response.filter.suitcases.min;
            vm.filter_setting.suitcases.max = _response.filter.suitcases.max;
        }


    }

    function initSlider() {
        if (vm.filters && vm.filters.prices) {
            var slide_price = new Slider("#prices", {
                min: vm.filters.prices.min,
                max: vm.filters.prices.max,
                value: [vm.filters.prices.min, vm.filters.prices.max]
            });

            var slide_passengers = new Slider("#passengers_list", {
                min: vm.filters.passengers.min,
                max: vm.filters.passengers.max,
                value: vm.filters.passengers.min
            });

            var slide_suitcases = new Slider("#suitcases_list", {
                min: vm.filters.suitcases.min,
                max: vm.filters.suitcases.max,
                value: [vm.filters.suitcases.min, vm.filters.suitcases.max]
            });

            slide_price.on("slide", onChangeRangePrice);
            slide_price.on("slideStop", onChangeRangePrice);

            slide_passengers.on("slide", onChangeRangePassengers);
            slide_passengers.on("slideStop", onChangeRangePassengers);

            slide_suitcases.on("slide", onChangeRangeSuitcases);
            slide_suitcases.on("slideStop", onChangeRangeSuitcases);
        }

    }


    function onChangeRangePrice(values) {
        $scope.$apply(function () {
            var min = values[0] || 0;
            var max = values[1] || 0;
            vm.filter_setting.price.min = min;
            vm.filter_setting.price.max = max;
        });
    }


    function onChangeRangePassengers(values) {

        $scope.$apply(function () {
            //var min = values[0] || 0;
            //var max = values[1] || 0;
            var min = values || 0;
            vm.filter_setting.passengers.min = min;
            //vm.filter_setting.passengers.max = max;
        });
    }


    function onChangeRangeSuitcases(values) {

        $scope.$apply(function () {
            var min = values[0] || 0;
            var max = values[1] || 0;
            vm.filter_setting.suitcases.min = min;
            vm.filter_setting.suitcases.max = max;
        });
    }

    function GoogleViewItemList() {
        try {
            ListAnalytic.setViewItemList(window.__mt.list, config.box);
            //ListAnalyticV1.setViewItemList(window.__mt.list);
        } catch (error) {
            console.log(error)
        }
    }

    function GoogleAddToCart(item, index) {
        try {
            localStorageService.set('ga_index', index + 1)
            ListAnalytic.setAddToCart(window.__mt.list, item, index + 1, config.box);
            //ListAnalyticV1.setAddToCart(window.__mt.list, item, index);
        } catch (error) {
            console.log(error)
        }
    }
}
